import { CmsVenueReviewsPage } from 'js/model/cms/cms-venue-reviews-page';
import { VenueTypeUrisOutput } from 'js/model/rainbow/venue/VenueTypeUrisOutput';
import { PropsType } from 'js/types/react';
import { VenueTypeLinks } from 'js/pages/VenuePage/VenueReviewsSection/VenueReviews/VenueTypeLinks';
import { substitute } from 'js/helpers/i18n';

export function createVenueTypeLinksViewModel(
  cms: CmsVenueReviewsPage,
  venueTypeUris: VenueTypeUrisOutput
): PropsType<typeof VenueTypeLinks> {
  return {
    heading: cms.page['venue-reviews']['venue-type-links-heading'],
    venueTypes: venueTypeUris.venueTypes.map((venueType) => ({
      label: substitute(
        cms.page['venue-reviews']['venue-type-browse-link'],
        venueType.name,
        venueTypeUris.location.name
      ),
      uri: venueType.uri.desktopUri,
    })),
    location: {
      label: substitute(
        cms.page['venue-reviews']['venue-location-browse-link'],
        venueTypeUris.location.name
      ),
      uri: venueTypeUris.location.uri.desktopUri,
    },
  };
}
